import React, { FC } from 'react';

export const SignOut: FC = () => {
  if ( !window.isLoggedIn ) return null;

  return (
    <a href="/sign-out" data-turbolinks="false">
      Sign Out
    </a>
  );
};
